export interface Image {
  alt: string | null
  src: string | null
  imageType: ImageTypes | null
  supportingColor?: string | null
}

export enum ImageTypes {
  Master = 'master',
  Standard = 'standard',
  Square = 'square',
}
